import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { APPROVAL_ACTION_CONFIGURATION, APPROVAL_ACTION_CONFIGURATION_SUCCESS, APPROVAL_ACTION_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* approvalActionConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/configurations/benefit-type/airport-transfer/approval-action`,
      method: 'POST',
      data: payload?.body,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: APPROVAL_ACTION_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: APPROVAL_ACTION_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_ACTION_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchapprovalActionConfiguration() {
  yield takeEvery(APPROVAL_ACTION_CONFIGURATION, approvalActionConfiguration);
}

function* approvalActionConfigurationSaga() {
  yield all([fork(watchapprovalActionConfiguration)]);
}

export default approvalActionConfigurationSaga;
